import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import "../../../assets/css/patient/patientlayouts/PatientMasterlayout.css";
import MyNavbar from "../../../components/general/navbar/MyNavbar";
// import Footer from "../../../components/general/footer/Footer";
import PatientSidebar from "./PatientSidebar";
import { FaBars } from "react-icons/fa";

const PatientMasterLayout = () => {
  const [isMobileSidebarOpen, setIsMobileSidebarOpen] = useState(false);

  const openMobileSidebar = () => setIsMobileSidebarOpen(true);
  const closeMobileSidebar = () => setIsMobileSidebarOpen(false);

  return (
    <>
      {/* Navbar */}
      <MyNavbar />
      {/* Sidebar is inside "patient-layout" so it stays sticky alongside the
          content and ends before the Footer. */}
      <div className="patient-layout">
        <PatientSidebar
          isMobileOpen={isMobileSidebarOpen}
          onCloseMobile={closeMobileSidebar}
        />
        <main className="patient-main-content">
          {/* Mobile-only trigger to open the sidebar — hidden on
              desktop/tablet via CSS (see PatientMasterlayout.css @768px).
              The sidebar itself has no visible way to open on mobile
              (its own collapse-button is hidden there), so this button
              is what actually lets mobile users reach the menu. */}
          <button
            type="button"
            className="patient-mobile-menu-btn"
            onClick={openMobileSidebar}
            aria-label="Open menu"
          >
            <FaBars />
            <span>Menu</span>
          </button>
          <div className="patient-content-area">
            <Outlet />
          </div>
        </main>
      </div>
      {/* Footer is outside "patient-layout", so it gets full width. */}
      {/* <Footer /> */}
    </>
  );
};

export default PatientMasterLayout;